/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Table,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import { callAPI } from 'lorautils/api';
import InlineSelect from 'loracoms/InlineSelect';
import LoadingTable from 'loracoms/LoadingTable';
import SortBtn from 'loracoms/SortBtn';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
};

class UnauthorizedPacketView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      initialStatus: 'pending',
      queryHours: 24,
      sortKey: '',
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.UnauthorizedPacketView');
  }

  componentDidMount() {
    this.mounted = true;
    this.loadNetworkAnalysisList();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadNetworkAnalysisList() {
    this.setState({ initialStatus: 'pending' });

    callAPI({
      endpoint: '/na/unauthorized_packet_summary',
      query: {
        hours: this.state.queryHours,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          initialStatus: 'success',
          tableData: data,
        });
      }
    }).catch(() => {
      this.setState({
        initialStatus: 'failure',
      });
    });
  }

  handleSort(sort) {
    const tableData = this.state.tableData || [];
    let sortOrder = true;
    let sortKey = '';
    if (sort.startsWith('-')) {
      sortOrder = true;
      sortKey = sort.substr(1);
    } else {
      sortOrder = false;
      sortKey = sort;
    }
    if (sortKey.endsWith('percentile')) {
      tableData.sort((a, b) => {
        if (sortOrder) {
          return a[sortKey][1] >= b[sortKey][1];
        }
        return a[sortKey][1] <= b[sortKey][1];
      });
    } else {
      tableData.sort((a, b) => {
        if (sortOrder) {
          return a[sortKey] >= b[sortKey];
        }
        return a[sortKey] <= b[sortKey];
      });
    }

    this.setState({
      tableData,
      sortKey,
    });
  }

  render() {
    const { initialStatus, sortKey, tableData } = this.state;
    const thead = (
      <thead>
        <tr>
          <th>
            {this.intlMsg.msg('thead.devaddr')}
            <SortBtn
              sortName="devaddr"
              highLight={sortKey === 'devaddr'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.deveui')}
            <SortBtn
              sortName="deveui"
              highLight={sortKey === 'deveui'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.gateway')}
            <SortBtn
              sortName="gateway"
              highLight={sortKey === 'gateway'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.frequency')}
            <SortBtn
              sortName="frequency"
              highLight={sortKey === 'frequency'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.toa_total')}
            <SortBtn
              sortName="toa_total"
              highLight={sortKey === 'toa_total'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
          <th>
            {this.intlMsg.msg('thead.total')}
            <SortBtn
              sortName="total"
              highLight={sortKey === 'total'}
              handleSort={s => this.handleSort(s)}
            />
          </th>
        </tr>
      </thead>
    );
    const hoursStr = this.intlMsg.msg('hours');
    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <InlineSelect
          options={[{
            label: `1 ${hoursStr}`,
            value: 1,
          }, {
            label: `6 ${hoursStr}`,
            value: 6,
          },
          {
            label: `12 ${hoursStr}`,
            value: 12,
          }, {
            label: `24 ${hoursStr}`,
            value: 24,
          }, {
            label: `72 ${hoursStr}`,
            value: 72,
          }]}
          values={[this.state.queryHours]}
          onChange={(selected) => {
            this.setState({
              queryHours: selected[0],
            }, () => {
              this.loadNetworkAnalysisList();
            });
          }}
        />
      )],
    }];
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar
              brandTitle={this.intlMsg.msg('title')}
              rightTools={rightTools}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel
              className={styles.panel}
              bsStyle="aisz-white"
              header={this.intlMsg.msg('tableHeader')}
            >
              {initialStatus === 'success' &&
              <Table className="aisz-table-light" striped hover bordered responsive>
                {thead}
                <tbody>
                  {
                    tableData.map((r, idx) => (
                      <tr key={String(idx)}>
                        <td>{r.devaddr}</td>
                        <td>{r.deveui}</td>
                        <td>{r.gateway}</td>
                        <td>{r.frequency}</td>
                        <td>{r.toa_total}</td>
                        <td>{r.total}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
              }
              {initialStatus === 'pending' &&
                <LoadingTable cols={6} rows={1} className="aisz-table-light">
                  {thead}
                </LoadingTable>
              }
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

UnauthorizedPacketView.propTypes = propTypes;

export default injectIntl(UnauthorizedPacketView);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/UnauthorizedPacketView/index.jsx